/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExportedCredential } from './ExportedCredential';
import {
    ExportedCredentialFromJSON,
    ExportedCredentialFromJSONTyped,
    ExportedCredentialToJSON,
    ExportedCredentialToJSONTyped,
} from './ExportedCredential';
import type { PersonRet } from './PersonRet';
import {
    PersonRetFromJSON,
    PersonRetFromJSONTyped,
    PersonRetToJSON,
    PersonRetToJSONTyped,
} from './PersonRet';
import type { OrganizationDetails } from './OrganizationDetails';
import {
    OrganizationDetailsFromJSON,
    OrganizationDetailsFromJSONTyped,
    OrganizationDetailsToJSON,
    OrganizationDetailsToJSONTyped,
} from './OrganizationDetails';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface GetMeResp
 */
export interface GetMeResp {
    /**
     * 
     * @type {PersonRet}
     * @memberof GetMeResp
     */
    person: PersonRet;
    /**
     * 
     * @type {Array<OrganizationDetails>}
     * @memberof GetMeResp
     */
    organizations: Array<OrganizationDetails>;
    /**
     * 
     * @type {Array<PersonHandle>}
     * @memberof GetMeResp
     */
    handles: Array<PersonHandle>;
    /**
     * 
     * @type {Array<ExportedCredential>}
     * @memberof GetMeResp
     */
    credentials: Array<ExportedCredential>;
}

/**
 * Check if a given object implements the GetMeResp interface.
 */
export function instanceOfGetMeResp(value: object): value is GetMeResp {
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('organizations' in value) || value['organizations'] === undefined) return false;
    if (!('handles' in value) || value['handles'] === undefined) return false;
    if (!('credentials' in value) || value['credentials'] === undefined) return false;
    return true;
}

export function GetMeRespFromJSON(json: any): GetMeResp {
    return GetMeRespFromJSONTyped(json, false);
}

export function GetMeRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeResp {
    if (json == null) {
        return json;
    }
    return {
        
        'person': PersonRetFromJSON(json['person']),
        'organizations': ((json['organizations'] as Array<any>).map(OrganizationDetailsFromJSON)),
        'handles': ((json['handles'] as Array<any>).map(PersonHandleFromJSON)),
        'credentials': ((json['credentials'] as Array<any>).map(ExportedCredentialFromJSON)),
    };
}

export function GetMeRespToJSON(json: any): GetMeResp {
    return GetMeRespToJSONTyped(json, false);
}

export function GetMeRespToJSONTyped(value?: GetMeResp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person': PersonRetToJSON(value['person']),
        'organizations': ((value['organizations'] as Array<any>).map(OrganizationDetailsToJSON)),
        'handles': ((value['handles'] as Array<any>).map(PersonHandleToJSON)),
        'credentials': ((value['credentials'] as Array<any>).map(ExportedCredentialToJSON)),
    };
}

